import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, name, ...props }) => {
  if (IconComponent) return <IconComponent {...props} />;
  
  const DynamicIcon = name ? FiIcons[`Fi${name}`] : null;
  if (DynamicIcon) return <DynamicIcon {...props} />;
  
  return <FiAlertTriangle {...props} />;
};

export default SafeIcon;